module.exports = __webpack_public_path__ + "static/appstore-257f6bd976b6a5235ad8ad3e822cb88d.png";